// Funkcja do konwersji liczby na słowa po polsku
export const numberToWords = (num) => {
  if (num === 0) return 'zero';
  
  const ones = ['', 'jeden', 'dwa', 'trzy', 'cztery', 'pięć', 'sześć', 'siedem', 'osiem', 'dziewięć'];
  const teens = ['dziesięć', 'jedenaście', 'dwanaście', 'trzynaście', 'czternaście', 'piętnaście', 'szesnaście', 'siedemnaście', 'osiemnaście', 'dziewiętnaście'];
  const tens = ['', '', 'dwadzieścia', 'trzydzieści', 'czterdzieści', 'pięćdziesiąt', 'sześćdziesiąt', 'siedemdziesiąt', 'osiemdziesiąt', 'dziewięćdziesiąt'];
  const hundreds = ['', 'sto', 'dwieście', 'trzysta', 'czterysta', 'pięćset', 'sześćset', 'siedemset', 'osiemset', 'dziewięćset'];
  
  const convertHundreds = (n) => {
    if (n === 0) return '';
    if (n < 10) return ones[n];
    if (n < 20) return teens[n - 10];
    if (n < 100) {
      const ten = Math.floor(n / 10);
      const one = n % 10;
      return tens[ten] + (one > 0 ? ' ' + ones[one] : '');
    }
    const hundred = Math.floor(n / 100);
    const remainder = n % 100;
    return hundreds[hundred] + (remainder > 0 ? ' ' + convertHundreds(remainder) : '');
  };
  
  const convert = (n) => {
    if (n === 0) return 'zero';
    
    let result = '';
    const billions = Math.floor(n / 1000000000);
    const millions = Math.floor((n % 1000000000) / 1000000);
    const thousands = Math.floor((n % 1000000) / 1000);
    const remainder = n % 1000;
    
    if (billions > 0) {
      result += convertHundreds(billions);
      if (billions === 1) result += ' miliard ';
      else if (billions < 5) result += ' miliardy ';
      else result += ' miliardów ';
    }
    
    if (millions > 0) {
      result += convertHundreds(millions);
      if (millions === 1) result += ' milion ';
      else if (millions < 5) result += ' miliony ';
      else result += ' milionów ';
    }
    
    if (thousands > 0) {
      result += convertHundreds(thousands);
      if (thousands === 1) result += ' tysiąc ';
      else if (thousands < 5) result += ' tysiące ';
      else result += ' tysięcy ';
    }
    
    if (remainder > 0) {
      result += convertHundreds(remainder);
    }
    
    return result.trim();
  };
  
  // Obsługa części dziesiętnych (grosze)
  const parts = num.toString().split('.');
  const zl = parseInt(parts[0]) || 0;
  const gr = parts[1] ? parseInt(parts[1].padEnd(2, '0').substring(0, 2)) : 0;
  
  let result = convert(zl);
  if (zl === 1) result += ' złoty';
  else if (zl < 5 && zl > 0) result += ' złote';
  else if (zl > 0) result += ' złotych';
  
  if (gr > 0) {
    result += ' ' + convert(gr);
    if (gr === 1) result += ' grosz';
    else if (gr < 5) result += ' grosze';
    else result += ' groszy';
  }
  
  return result;
};

